<script lang="ts">
  export let as = "button"
  export let secondary = false
  export let disabled = false

  $: aria = as === "button" ? {} : { role: "button", tabindex: 0 }
</script>

<svelte:element
  this={as}
  {...$$restProps}
  {...aria}
  class={$$restProps.class}
  class:button={/* anchor for external customization */ true}
  class:secondary
  class:disabled
  on:click
>
  <slot />
</svelte:element>

<style lang="postcss">
  * {
    @apply flex min-h-[3rem] cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-[14px] px-6 py-3 font-medium transition-colors;

    &.disabled {
      @apply cursor-not-allowed;
    }

    /* Primary styles by default */
    @apply primary;
  }

  :global([data-ui-scale="xs"]) *,
  :global([data-ui-scale="sm"]) * {
    @apply min-h-[2.5rem] rounded-xl px-5 py-2.5 text-sm/4;
  }

  :global([data-ui-scale="lg"]) *,
  :global([data-ui-scale="xl"]) * {
    @apply min-h-[3.75rem] px-8 py-4;
  }

  .primary {
    @apply bg-white text-black;

    &.disabled {
      @apply bg-opacity-10 text-white/10;
    }
  }

  .secondary {
    @apply border border-white/20 bg-black/30 text-white backdrop-blur-[20px];

    &.disabled {
      @apply text-opacity-20;
    }
  }

  /* TODO: Update Svelte to v4, https://svelte.dev/docs/v4-migration-guide#other-breaking-changes */
  /* https://stackoverflow.com/questions/74085350/backdrop-filter-doesnt-apply-if-parents-opacity-is-less-than-1 */
  :global([inert]) .secondary {
    @apply backdrop-blur-none;
  }
</style>
